module.exports = __webpack_public_path__ + "img/logout.85cb364d.svg";